module.exports = __webpack_public_path__ + "img/753.73a63a9a.jpg";